<script>
    import { onMount } from 'svelte';
    import Vivus from 'vivus';

    let showcaseSvg;

    onMount(() => {
        new Vivus(showcaseSvg, {
            type: 'delayed',
            start: 'autostart', 
            delay: 10,
            duration: 220,
            animTimingFunction: Vivus.EASE
        });
	});
</script>

<section class="container">
    <div class="columns">
        <div class="column col-8 col-lg-10 col-md-12 col-mx-auto showcase">
            <div class="p-relative showcase__container">
                <svg version="1.1" bind:this={ showcaseSvg } class="p-absolute showcase_image" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                        y="0px" viewBox="0 0 1920 864" style="enable-background:new 0 0 1920 864;" xml:space="preserve">
                    <style type="text/css">
                        .svg_path{fill:none;stroke-width:4;stroke-miterlimit:10;}
                    </style>
                    <g>
                        <path class="svg_path" d="M491.8,397.4c3.3,2,7.6,5,10.4,7.8s5.1,5.9,7.1,9.2c2,3.4,3.5,7,4.6,10.8c1.1,3.9,1.6,7.8,1.6,12.1
                            c0,6.2-1.2,12.1-3.6,17.7c-2.3,5.5-5.6,10.4-9.7,14.4s-8.9,7.4-14.4,9.7s-11.4,3.6-17.7,3.6h-22.7v22.7h-22.7V391.8h45.4
                            c4.1,0,8.2,0.5,12.1,1.6c3.8,1.2,7.4,2.7,10.8,4.7 M478.9,416.4c-2.7-1.2-5.7-1.8-8.8-1.8h-22.7V460h22.7c3.2,0,6-0.6,8.8-1.8
                            c2.7-1.2,5.1-2.8,7.2-4.9s3.7-4.5,4.9-7.2s1.8-5.7,1.8-8.8c0-3.2-0.6-6-1.8-8.8c-1.2-2.8-2.8-5.2-4.9-7.2
                            C484,419.3,481.6,417.5,478.9,416.4"/>
                        <path class="svg_path" d="M551.8,398.4c4.3-2.5,9-4.5,14.1-5.9c5-1.4,10.2-2.1,15.6-2.1s10.5,0.7,15.6,2.1c5,1.4,9.7,3.3,14.1,5.9
                            c4.3,2.5,8.3,5.6,11.9,9.2c3.6,3.6,6.7,7.6,9.2,11.9s4.5,9,5.9,14.1c1.4,5,2.1,10.2,2.1,15.6s-0.7,10.5-2.1,15.6
                            c-1.4,5-3.3,9.6-5.9,14.1c-2.5,4.4-5.6,8.3-9.2,11.9c-3.6,3.6-7.6,6.7-11.9,9.2s-9,4.5-14.1,5.9c-5,1.4-10.2,2.1-15.6,2.1
                            s-10.5-0.7-15.6-2.1c-5-1.4-9.6-3.3-14.1-5.9c-4.3-2.5-8.3-5.7-11.9-9.2c-3.6-3.6-6.7-7.6-9.2-11.9s-4.5-9-5.9-14.1
                            c-1.4-5-2.1-10.2-2.1-15.6s0.7-10.5,2.1-15.6c1.4-5,3.3-9.7,5.9-14.1c2.5-4.3,5.7-8.3,9.2-11.9C543.5,404,547.4,400.9,551.8,398.4
                            M567.3,415.8c-4.4,1.9-8.2,4.5-11.4,7.7c-3.2,3.2-5.9,7.1-7.7,11.4c-1.9,4.4-2.9,9.1-2.9,14.1s1,9.6,2.9,14
                            c1.9,4.3,4.5,8.2,7.7,11.4c3.2,3.2,7.1,5.9,11.4,7.7c4.4,1.9,9.1,2.9,14.1,2.9s9.6-1,14.1-2.9c4.4-1.9,8.2-4.5,11.4-7.7
                            c3.2-3.2,5.9-7.1,7.7-11.4c1.9-4.3,2.9-9,2.9-14s-1-9.6-2.9-14.1c-1.9-4.4-4.5-8.2-7.7-11.4c-3.2-3.2-7.1-5.9-11.4-7.7
                            c-4.4-1.9-9.1-2.9-14.1-2.9C576.4,413,571.6,413.9,567.3,415.8"/>
                        <path class="svg_path" d="M676.3,414.5l-34.1,0.1v-22.7H733v22.7H699v90.8h-22.6l-0.5-92.9"/>
                        <path class="svg_path" d="M768.1,395.5c5.5-2.3,11.4-3.6,17.7-3.6s12.2,1.2,17.7,3.6c5.5,2.3,10.4,5.6,14.4,9.7s7.4,8.9,9.7,14.4
                            s3.6,11.4,3.6,17.7v68.1h-22.7v-22.7h-45.4v22.7h-22.6v-68.1c0-6.3,1.2-12.2,3.6-17.7c2.3-5.5,5.6-10.4,9.7-14.4
                            C757.8,401,762.6,397.8,768.1,395.5 M777,416.4c-2.8,1.2-5.2,2.8-7.2,4.9s-3.7,4.5-4.9,7.2s-1.8,5.7-1.8,8.8V460h45.4v-22.7
                            c0-3.2-0.6-6-1.8-8.8s-2.8-5.2-4.9-7.2c-2.1-2-4.5-3.7-7.2-4.9s-5.7-1.8-8.8-1.8C782.6,414.5,779.7,415.2,777,416.4"/>
                        <path class="svg_path" d="M872.6,414.5l-34.2,0.1v-22.7h90.8v22.7h-34.1v90.8h-22.6l-0.4-92.4"/>
                        <path class="svg_path" d="M933.6,433.5c1.4-5,3.3-9.7,5.9-14.1c2.5-4.3,5.7-8.3,9.2-11.9c3.6-3.6,7.6-6.7,11.9-9.2
                            c4.3-2.5,9-4.5,14.1-5.9c5-1.4,10.2-2.1,15.6-2.1s10.5,0.7,15.6,2.1c5,1.4,9.7,3.3,14.1,5.9c4.3,2.5,8.3,5.6,11.9,9.2
                            c3.6,3.6,6.7,7.6,9.2,11.9s4.5,9,5.9,14.1c1.4,5,2.1,10.2,2.1,15.6s-0.7,10.5-2.1,15.6c-1.4,5-3.3,9.6-5.9,14.1
                            c-2.6,4.5-5.6,8.3-9.2,11.9c-3.6,3.6-7.6,6.7-11.9,9.2c-4.3,2.5-9,4.5-14.1,5.9c-5,1.4-10.2,2.1-15.6,2.1s-10.5-0.7-15.6-2.1
                            s-9.6-3.3-14.1-5.9c-4.3-2.5-8.3-5.7-11.9-9.2c-3.6-3.6-6.7-7.6-9.2-11.9s-4.5-9-5.9-14.1c-1.4-5-2.1-10.2-2.1-15.6
                            C931.6,443.6,932.2,438.5,933.6,433.5 M957,435c-1.9,4.4-2.9,9.1-2.9,14.1s1,9.6,2.9,14c1.9,4.3,4.5,8.2,7.7,11.4
                            c3.2,3.2,7.1,5.9,11.4,7.7c4.4,1.9,9.1,2.9,14.1,2.9s9.6-1,14.1-2.9c4.4-1.9,8.2-4.5,11.4-7.7s5.9-7.1,7.7-11.4s2.9-9,2.9-14
                            s-1-9.6-2.9-14.1c-1.9-4.4-4.5-8.2-7.7-11.4s-7.1-5.9-11.4-7.7c-4.4-1.9-9.1-2.9-14.1-2.9s-9.7,1-14.1,2.9
                            c-4.4,1.9-8.2,4.5-11.4,7.7C961.5,426.8,958.8,430.7,957,435"/>
                        <path class="svg_path" d="M1057.1,425.9c0-4.7,0.9-9.1,2.7-13.2s4.2-7.7,7.3-10.8c3.1-3.1,6.7-5.5,10.8-7.3s8.6-2.7,13.2-2.7h52.1v22.7
                            h-52.1c-1.6,0-3.1,0.3-4.4,0.9c-1.4,0.5-2.6,1.4-3.6,2.4c-1,1.1-1.8,2.3-2.4,3.6c-0.5,1.4-0.9,2.9-0.9,4.4s0.3,3.1,0.9,4.5
                            c0.5,1.4,1.4,2.6,2.4,3.6c1.1,1,2.3,1.8,3.6,2.4c1.4,0.5,2.9,0.9,4.4,0.9h22.7c4.7,0,9.1,0.9,13.2,2.6c4.1,1.8,7.7,4.2,10.8,7.3
                            c3.1,3.1,5.5,6.7,7.3,10.8c1.8,4.1,2.6,8.6,2.6,13.2s-0.9,9.1-2.6,13.2c-1.8,4.1-4.2,7.7-7.3,10.8s-6.7,5.5-10.8,7.3
                            c-4.1,1.8-8.6,2.7-13.2,2.7h-50.4v-22.7h50.4c1.6,0,3.1-0.3,4.4-0.9c1.4-0.5,2.6-1.4,3.6-2.4s1.8-2.3,2.4-3.6
                            c0.5-1.4,0.9-2.9,0.9-4.4s-0.3-3.1-0.9-4.4c-0.5-1.4-1.4-2.6-2.4-3.6c-1.1-1-2.3-1.8-3.6-2.4c-1.4-0.5-2.9-0.9-4.4-0.9h-22.7
                            c-4.7,0-9.1-0.9-13.2-2.7c-4.1-1.8-7.7-4.2-10.8-7.3c-3.1-3.1-5.5-6.7-7.3-10.8S1057.1,430.6,1057.1,425.9"/>
                        <path class="svg_path" d="M1185.7,389.9l-0.1,115.5h-22.7V391.8l23.2,0.1"/>
                        <path class="svg_path" d="M1288.4,390v24.6h-34.1v90.8h-22.6v-90.8h-34.1v-22.7l91.3,0.1"/>
                        <path class="svg_path" d="M1378.1,389.9l0.2,24.7h-55.1v22.7h37.3V460h-37.3v22.6h55.1v22.7h-77.8V391.8l78.5,0.1"/>
                        <path class="svg_path" d="M1388.9,412.7c1.8-4.1,4.2-7.7,7.3-10.8s6.7-5.5,10.8-7.3s8.6-2.7,13.2-2.7h52.1v22.7h-52.1
                            c-1.6,0-3.1,0.3-4.4,0.9c-1.4,0.5-2.6,1.4-3.6,2.4c-1,1.1-1.8,2.3-2.4,3.6c-0.5,1.4-0.9,2.9-0.9,4.4s0.3,3.1,0.9,4.5
                            c0.5,1.4,1.4,2.6,2.4,3.6c1.1,1,2.3,1.8,3.6,2.4c1.4,0.5,2.9,0.9,4.4,0.9h22.7c4.7,0,9.1,0.9,13.2,2.6c4.1,1.8,7.7,4.2,10.8,7.3
                            c3.1,3.1,5.5,6.7,7.3,10.8c1.8,4.1,2.6,8.6,2.6,13.2s-0.9,9.1-2.6,13.2c-1.8,4.1-4.2,7.7-7.3,10.8s-6.7,5.5-10.8,7.3
                            s-8.6,2.7-13.2,2.7h-50.4v-22.7h50.4c1.6,0,3.1-0.3,4.4-0.9c1.4-0.5,2.6-1.4,3.6-2.4s1.8-2.3,2.4-3.6c0.5-1.4,0.9-2.9,0.9-4.4
                            s-0.3-3.1-0.9-4.4c-0.5-1.4-1.4-2.6-2.4-3.6c-1.1-1-2.3-1.8-3.6-2.4c-1.4-0.5-2.9-0.9-4.4-0.9h-22.7c-4.7,0-9.1-0.9-13.2-2.7
                            c-4.1-1.8-7.7-4.2-10.8-7.3s-5.5-6.7-7.3-10.8c-1.8-4.1-2.7-8.6-2.7-13.2C1386.3,421.2,1387.1,416.8,1388.9,412.7"/>
                    </g>
                    <line class="svg_path" x1="425.3" y1="660" x2="1476.3" y2="612.2"/>
                </svg>
            </div>
        </div>
    </div>
</section>

<style lang="scss">
    .container{
        margin-top: -80px;
    }
    .showcase{
        &__container{
            height: 0;
            padding-bottom: 45%;
        }
        .showcase_image{
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
        }
    }
    @media screen and (max-width: 600px) {
        .container{
            margin-top: -20px;
        }
    }
</style>